module.exports = __webpack_public_path__ + "media/images/clippy-89bd48cba1a18d01645b006b59a83026.svg";